import { render } from "./AssignedResourceTaskSetting.vue?vue&type=template&id=4f89be6a&scoped=true&ts=true"
import script from "./AssignedResourceTaskSetting.vue?vue&type=script&lang=ts"
export * from "./AssignedResourceTaskSetting.vue?vue&type=script&lang=ts"

import "./AssignedResourceTaskSetting.vue?vue&type=style&index=0&id=4f89be6a&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f89be6a"]])

export default __exports__